import { useState } from "react";
import { FeatureList } from "@/components/features/feature-list";

import { FeatureFilters } from "@/components/features/feature-filters";

import { usePageTitle } from "@/hooks/use-page-title";

import type { FeatureFilters as Filters } from "@/lib/api/features";

export function InboxPage() {
  usePageTitle("Inbox");

  const [filters, setFilters] = useState<Filters>({
    assignee: "me", // Default to current user
  });

  const updateFilters = (newFilters: Filters) => {
    // Keep assignee: "me" for inbox unless explicitly cleared via assigneeId
    setFilters({
      ...newFilters,
      assignee: newFilters.assigneeId ? undefined : "me",
    });
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between p-4 md:p-6 border-b">
        <div>
          <h1 className="text-lg font-medium">Inbox</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Features assigned to you
          </p>
        </div>

      </div>

      <FeatureFilters filters={filters} onChange={updateFilters} />

      <div className="flex-1">
        <FeatureList filters={filters} />
      </div>


    </div>
  );
}
